import type { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash-es';

import { ProductTypeEnum } from '@src/types/types';
import type { Leaves } from '@src/utils/types';
import { AgGridCurrency, AgGridSecurity, type AgGridCurrencyProps, type AgGridSecurityProps } from '../../AgGrid';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';

export interface AssetColumnProps<T extends object = any>
  extends Partial<AgGridCurrencyProps>, Partial<AgGridSecurityProps> {
  assetTypeField?: Leaves<T>;
}

/**
 * Column that represents BOTH Securities and Currencies, renders both well
 *
 * - TODO - it does NOT yet support certain properties that the 'security' and 'currency' columns do, such as securityCurrencyField
 */
export const asset: ColDefFactory<Column<AssetColumnProps>> = (column => ({
  ...baseColumn(column),
  cellRendererParams: column.params,
  cellRenderer: (params: ICellRendererParams) => {
    const assetTypeProp = column.params?.assetTypeField || '';

    const isCurrency =
      assetTypeProp && params.data
        ? get(params.data, assetTypeProp) === ProductTypeEnum.Spot
        : params.context?.current?.currenciesBySymbol?.has(params.value);
    return isCurrency ? (
      <AgGridCurrency {...column.params} {...params} />
    ) : (
      <AgGridSecurity {...column.params} {...params} />
    );
  },
})) satisfies ColDefFactory<Column<AssetColumnProps>>;
